var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KChip',_vm._b({attrs:{"medium":_vm.medium}},'KChip',_vm.type,false),[_vm._v(_vm._s(_vm.method))])
}
var staticRenderFns = []

export { render, staticRenderFns }